module.exports = __webpack_public_path__ + "static/media/copy_icon.fab7cb31.svg";